import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface MenuSectionItem {
  label: string;
  value: string;
  icon?: IconDefinition;
}

export interface MenuSectionProps {
  title: string;
  items: MenuSectionItem[];
  currentValue?: string;
  onChange: (value: string) => void;
}

/**
 * Reusable menu section component for PulseColumnMenu
 * Provides a consistent look and feel for menu sections with selectable items
 */
export const MenuSection: React.FC<MenuSectionProps> = ({
  title,
  items,
  currentValue,
  onChange,
}) => {
  return (
    <>
      {/* Section Title */}
      <div className="px-3 py-2 text-xs font-semibold text-neutral-500 uppercase tracking-wide">
        {title}
      </div>

      {/* Section Items */}
      {items.map((item) => (
        <button
          key={item.value}
          onClick={(e) => {
            e.stopPropagation();
            onChange(item.value);
          }}
          className={`w-full px-4 py-2 text-sm text-left hover:bg-neutral-100 transition-colors flex items-center justify-between ${
            currentValue === item.value
              ? 'bg-teal-50 text-teal-700 font-medium'
              : ''
          }`}
        >
          <span className="flex items-center gap-2">
            {item.icon && (
              <Icon icon={item.icon} className="text-xs" />
            )}
            {item.label}
          </span>
          {currentValue === item.value && (
            <Icon icon={faCheck} className="text-xs" />
          )}
        </button>
      ))}
    </>
  );
};

export default MenuSection;
